class LoadingIndicator extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        .overlay{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.3);z-index:9999}
        .spinner{width:64px;height:64px;border-radius:50%;border:8px solid rgba(255,255,255,0.2);border-top-color:#fff;animation:spin 1s linear infinite}
        @keyframes spin{to{transform:rotate(360deg)}}
      </style>
      <div class="overlay" role="status" aria-hidden="false">
        <div class="spinner"></div>
      </div>
    `;
  }
}
customElements.define('loading-indicator', LoadingIndicator);
